import React from 'react';
import ReactDOM from 'react-dom/client';
import { Router } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import 'antd/dist/antd.less';
import ja_JP from 'antd/es/locale/ja_JP';
import './scss/index.less';
import './scss/calendar.less';
import './scss/pdf.less';

import App from './Layout';
import AppProvider from './contexts/AppContext';
import '@/helpers/i18n';
import history from './history';
import moment from 'moment';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import 'moment/locale/ja';
import dayjs from 'dayjs';
require('dayjs/locale/ja');

moment.locale('ja');
dayjs.locale('ja');

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <AppProvider>
    <Router history={history}>
      <ConfigProvider locale={ja_JP}>
        <GoogleReCaptchaProvider reCaptchaKey={process.env.REACT_APP_GOOGLE_CAPTCHA || ''}>
          <App />
        </GoogleReCaptchaProvider>
      </ConfigProvider>
    </Router>
  </AppProvider>,
);
